import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import { Box, Button } from '@chakra-ui/react';
import { v4 as uuidv4 } from 'uuid';

import Text from './Text';
import { dateDiff, reverseArray } from '../utils/core';
import DetailRow from './DetailRow';
import { getFullSteps } from '../lib/workflow';
import { AppContext } from '../AppContext';

const transactionLinkFunctions = {
  rinkeby: tx => `https://rinkeby.etherscan.io/tx/${tx}`,
  mainnet: tx => `https://etherscan.io/tx/${tx}`,
  palm: tx => `https://explorer.palm.io/tx/${tx}`,
  'palm-test': tx => `https://explorer.palm-uat.xyz/tx/${tx}`,
};
const generateTransactionLink = ({ chain, transactionHash }) =>
  (transactionLinkFunctions[chain] || (() => {}))(transactionHash);

const EventLogs = ({ transfer = {}, ...props }) => {
  const { logs = [], completed, id } = transfer;
  const { store, actions } = useContext(AppContext);
  const showMore = store.expandedEventLogs[id];
  const toggleShowMore = () => actions.setExpandedEventLog(id, !showMore);
  const reversedLogs = reverseArray(logs).map(log => ({
    ...log,
    link: generateTransactionLink(log),
  }));
  const getSteps = () => getFullSteps({ ...transfer, logs: reversedLogs });
  const [steps, setSteps] = useState([]);
  useEffect(() => {
    let { steps = [] } = getSteps();
    steps = steps.filter(({ completed, hidden }) => completed && (showMore || !hidden));
    setSteps(steps);
  }, [JSON.stringify(logs), showMore]);
  return (
    <Box p={['3px', '20px']} {...props}>
      <Text textStyle="h4" as="h4">Event logs</Text>
      {
        steps.length
          ? (
            <>
              <Box>
                {steps.map(({ label, link, blockCreated, logIndex }, index) => (
                  <DetailRow
                    key={uuidv4()}
                    label={label}
                    title={`${moment(blockCreated).format()} (log index: ${logIndex})`}
                    value={
                    (completed || steps.latestStepState === 'completed')
                      ? `${moment(blockCreated).fromNow()}`
                      : `${dateDiff(new Date(), moment(blockCreated))}${moment(blockCreated) ? ' ago' : '-'}`
                  }
                    externalLink={link}
                    bold={!completed && steps.latestStepIndex === index}
                    style={{ ...(!index && { marginTop: '20px' }) }}
                    mb="15px"
                    labelProps={{ asHtml: true, ...(completed && { width: '75%' }) }}
                  />
                ))}
              </Box>
              <Button
                _hover={{ textDecoration: 'underline', backgroundColor: 'transparent' }}
                _focus={{ outline: 'none', boxShadow: 'none', backgroundColor: 'transparent' }}
                _active={{ outline: 'none', boxShadow: 'none', backgroundColor: 'transparent' }}
                style={{ backgroundColor: 'transparent', height: 'fit-content', border: 'none' }}
                textStyle="body"
                fontWeight="light"
                p={0}
                mt="10px"
                onClick={toggleShowMore}
              >
                {`Show ${showMore ? 'less' : 'more'} detail`}
              </Button>
            </>
          )
          : (<Text textStyle="bodyGrey2" fontWeight="light" mt="10px">No logs available</Text>)
      }
    </Box>
  );
};

export default EventLogs;
